<template>
  <v-app>
    <v-container style="height: 400px;" v-show=loading>
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="subtitle-1 text-center" cols="12">
          Fetching more records
        </v-col>
        <v-col cols="6">
          <v-progress-linear color="#FF3301" indeterminate rounded height="6" />
        </v-col>
      </v-row>
    </v-container>
    <v-col cols="10" style="height: 300px; align-self: center" v-show=!loading>
      <v-row>
        <v-btn :disabled="isExportLoading" text normal color="#FF3401" @click="exportAll">
          <template v-if="isExportLoading">
            <v-progress-circular indeterminate color="#FF3401" size="20"></v-progress-circular>
          </template>
          <template v-else>
            Export All
          </template>
        </v-btn>
        <v-btn text color="#FF3401" @click="goToAdmin">Admin</v-btn>
      </v-row>
      <v-row>
        <v-expansion-panels :accordion=true :multiple=true center>
          <UserTable v-for="user in results" v-bind:key="user.firebaseId" :user="user" />
        </v-expansion-panels>
      </v-row>
      <div class="text-center">
        <v-container>
          <v-row justify="center">
            <v-col cols="10">
              <v-container class="max-width">
                <v-btn text color="#FF3401" @click="getPrev()">Prev</v-btn>
                <v-btn text color="#FF3401" @click="getNext()">Next</v-btn>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-col>
    <v-snackbar v-model="snackbar" :timeout="timeout">
      An Error Occurred
    </v-snackbar>
  </v-app>
</template>

<script>
import axios from 'axios';
import firebase from 'firebase/app';
import 'firebase/auth';
import UserTable from './UserTable.vue';

export default {
  name: 'App',
  components: {
    UserTable,
  },
  data() {
    return {
      results: [],
      snackbar: false,
      timeout: 1000,
      loading: true,
      isExportLoading: false,
    };
  },
  methods: {
    goToAdmin() {
      this.$router.push('/admin');
    },
    getPrev() {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/users?endBefore=${this.results[0].email}`, { headers: { Authorization: localStorage.token } })
        .then((response) => {
          if (response.data.length !== 0) {
            this.results = response.data.reverse();
          }
          this.loading = false;
        })
        .catch((err) => {
          this.onError(err);
        });
    },
    getNext() {
      this.loading = true;
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/users?startAfter=${this.results[this.results.length - 1].email}`, { headers: { Authorization: localStorage.token } })
        .then((response) => {
          if (response.data.length !== 0) {
            this.results = response.data;
          }
          this.loading = false;
        })
        .catch((err) => {
          this.onError(err);
        });
    },
    exportAll() {
      this.isExportLoading = true;
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/export/users`, { headers: { Authorization: localStorage.token } })
        .then((response) => {
          if (response.data.length !== 0) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'export.csv');
            document.body.appendChild(link);
            link.click();
          }
        }).catch((err) => {
          this.onError(err);
        }).finally(() => {
          this.isExportLoading = false;
        });
    },
    getUsers() {
      axios.get(`${process.env.VUE_APP_BACKEND_URL}/users`, { headers: { Authorization: localStorage.token } })
        .then((response) => {
          this.results = response.data;
          this.loading = false;
        }).catch((err) => {
          this.onError(err);
        });
    },
    onError(err) {
      this.snackbar = true;
      this.loading = false;
      if (err.response.status === 403 || err.response.status === 401) {
        localStorage.clear();
        this.$router.replace('/login');
      }
    },
  },
  mounted() {
    if (localStorage.token == null) {
      firebase.auth().currentUser.getIdToken(true)
        .then((token) => {
          localStorage.token = token;
          this.getUsers();
        }).catch(() => {
          this.snackbar = true;
          this.loading = false;
        });
    } else {
      this.getUsers();
    }
  },
};
</script>

<style scoped>

</style>
